<template lang="pug">
.sidebar
  .topnavbar
    .con
      .nlbar
        .logo
          router-link(to="/" @click.native="toggleSidebar()")
            img(src='/new/img/logo.png')
        language
  .items.sp
    template(v-if="isLoggedIn")
      router-link.btns.deposit(to="/deposit" @click.native="toggleSidebar()")
        span Deposit
        img(src='/new/img/menu/sm-deposit.png')
      router-link.btns.vip(to="/vip" @click.native="toggleSidebar()")
        span VIP
        img(src='/new/img/menu/sm-vip.png')
      router-link.btns.referral(to="/referral" @click.native="toggleSidebar()")
        span Referral
        img(src='/new/img/menu/sm-referral.png')
    template(v-else)
      router-link.btns.referral(to="/referral" @click.native="toggleSidebar()")
        span Referral
        img(src='/new/img/menu/sm-referral.png')
      a.btns.livechat(href="javascript:void(0)" @click="openChat();toggleSidebar()")
        span Live Chat
        img(src='/new/img/menu/sm-livechat.png')
      router-link.btns.review(to='/review' @click.native="toggleSidebar()")
        span Review
        img(src='/new/img/menu/sm-review.png')
  .items
    router-link.btns(to='/promotions' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/promotions'}")
      span Promotion
      img(src='/new/img/menu/m-promo.png')
    //- router-link.btns(to='/missions')
      span Mission
      img(src='/new/img/menu/m-mission.png')
    template(v-if="isLoggedIn")
      router-link.btns(to='/statement' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/statement'}")
        span Statement
        img(src='/new/img/menu/m-statement.png')
      router-link.btns(to='/inbox' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/inbox'}")
        span Rewards
        img(src='/new/img/menu/m-rewards.png')
      a.btns(href="javascript:void(0)" @click="openChat();toggleSidebar()")
        span Live Chat
        img(src='/new/img/menu/m-livechat.png')
      router-link.btns(to='/review' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/review'}")
        span Review
        img(src='/new/img/menu/m-review.png')
    template(v-else)
      a.btns(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
        span Statement
        img(src='/new/img/menu/m-statement.png')
      a.btns(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
        span Rewards
        img(src='/new/img/menu/m-rewards.png')
      a.btns(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
        span Deposit
        img(src='/new/img/menu/m-deposit.png')
      a.btns(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
        span VIP
        img(src='/new/img/menu/m-vip.png')
    router-link.btns(to='/contactUs' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/contactUs'}")
      span Follow
      img(src='/new/img/menu/m-follow.png')
    router-link.btns(to='/freeplay' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/freeplay'}")
      span Demo Play
      img(src='/new/img/menu/m-demo.png')
    router-link.btns(to='/news' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/news'}")
      span News
      img(src='/new/img/menu/m-news.png')
    a.btns(v-if="!isIOS" href="https://dapk.epwin21.com/epicwin.apk" target="_blank" @click="toggleSidebar()")
      span Download App
      img(src='/new/img/menu/m-app.png')
    a.btns(v-if="isIOS" href='javascript:void(0)' @click="openTutorial()")
      span Download App
      img(src='/new/img/menu/m-app.png')
    router-link(to='/partners' @click.native="toggleSidebar()")
      img.g-op(src='/new/img/menu/group.png')
      img.g-cl(src='/new/img/menu/group-m.png')
  .items.sp(v-if="isLoggedIn")
    a.btns.referral(href="javascript:void(0)" @click="logout")
      span {{$t('ui.logout')}}
      i.fa-solid.fa-arrow-right-from-bracket
</template>
<script>
import language from "@/component/_language.vue"
export default{
  components:{
    language
  },
  data(){
    return{
      currentPath:"",
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
    }
  },
  beforeMount(){
    this.getMobile()
  },
  mounted(){
    this.currentPath = this.$router.currentRoute.path
  },
  methods:{
    toggleSidebar(){
      if (window.innerWidth < 768){
        $('body').removeClass('hnb');
      }
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true;
      } else {
        this.isIOS = false;
      }
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    openTutorial() {
      $("#modal-tutorial").modal("show");
    },
    logout() {
      this.$store.dispatch("user/logout").catch(err => {});
    }
  }
}
</script>